// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ResultColumnHint-container-oTipH {\n  text-align: right;\n}\n.ResultColumnHint-logo-3beO1 {\n  margin-bottom: -0.4em;\n}\n.ResultColumnHint-arrow-1c7sP {\n  height: 12px;\n  margin-inline: 5px 20px;\n  transform: scale(-1, 1) translateY(5px) rotate(-25deg);\n}\n", ""]);
// Exports
exports.locals = {
	"container": "ResultColumnHint-container-oTipH",
	"logo": "ResultColumnHint-logo-3beO1",
	"arrow": "ResultColumnHint-arrow-1c7sP"
};
module.exports = exports;
